export default __webpack_public_path__ + "static/media/account-created.c27b6a30.gif";